// extracted by mini-css-extract-plugin
export var circle = "_t-2";
export var icon = "_t-a";
export var iconHighlight = "_t-0";
export var lg = "_t-8";
export var md = "_t-7";
export var outline = "_t-4";
export var sm = "_t-6";
export var square = "_t-1";
export var xl = "_t-9";
export var xs = "_t-5";
export var xxs = "_t-3";